// extracted by mini-css-extract-plugin
export default {"label":"Sms_label__lsEzn","text":"Sms_text__eTpag","error":"Sms_error__3pNqE"};